import {
  Events,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'

const template = `
  <span class="hs-status-bar hs-total-rows-status-bar">
    <span>Rows:</span> <span class="value ml-1">0</span>
  </span>
`

/**
 * `Rows: <displayed>` for the client-side workbench grids. Uses the same markup as the server-side
 * counterpart in `@helios/generic-components` so the two render identically wherever they appear.
 */
export class WorkbenchRowsStatusBarComp implements IStatusPanelComp {
  private readonly eGui = loadTemplate(template)

  private params?: IStatusPanelParams

  /** @internal */
  readonly modelUpdatedListener = () => this.refresh()

  init(params: IStatusPanelParams): void {
    this.params = params
    params.api.addEventListener(
      Events.EVENT_MODEL_UPDATED,
      this.modelUpdatedListener,
    )
    this.refresh()
  }

  destroy(): void {
    this.params?.api.removeEventListener(
      Events.EVENT_MODEL_UPDATED,
      this.modelUpdatedListener,
    )
  }

  getGui(): HTMLElement {
    return this.eGui
  }

  /** @internal */
  refresh(): void {
    const value = this.eGui.querySelector('.value')
    if (value != null) {
      value.textContent = `${this.params?.api.getDisplayedRowCount() ?? 0}`
    }
  }
}
